import Controller from '@ember/controller';

export default class MarketErrorController extends Controller {
  queryParams = ['reason'];

  reason = 'unknown';
}
